import DateFnsUtils from "@date-io/date-fns";
import { FormHelperText } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Prompt } from "react-router";
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import { harvestYearDetail } from "../../../config/harvestYearDetail";
import {
  commodityList,
  createContract,
  getCommodityVariertyList,
  getContractStage,
  getContractType,
  getCounterpartList,
  getDestinationByType
} from "../../../modules/contract/action";
import { getMandatoryFieldsList } from "../../../modules/mandatoryFields/action";
import "../../../style";
import { formatDate } from "../../../utils/DateFormatter";
import LogInfo from "../../../utils/LogInfo";
import Button from "../../FormElement/Button";
// import DatePickerElement from '../../FormElement/DatePickerElement'
import Dropdown from "../../FormElement/Dropdown";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";

var contractValue = 0;

const signInSectionStyle = {
  display: "flex",
  alignItems: "baseline",
  justifyContent: "space-between"
};

class ContractForm extends Component {
  handleVarietyonEdit = false;
  constructor(props) {
    super(props);

    this.state = {
      contractInfo: {
        ...this.props.contractInfo,
        maturityDate: this.props.contractInfo
          ? this.props.contractInfo.maturityDate
          : formatDate(new Date()),
        harvestYear: harvestYearDetail().name,

        // notes: null
      },
      ONBOARDED:'ONBOARDED',
      estmatederrormessage:false,
      formErrors: {
        contractNumber: "", //long
        contractTypeId: "", //long
        maturityDate: "",
        counterpartId: "", //long
        destinationId: "", //long
        contractStageId: "",
        commodityId: "", //long
        commodityVarietyId: "", //long
        bushelContracted: 0, //float
        unitPrice: 0, //float
        basis: 0, //float
        notes: ""
      },
      fetchingComplete: false,
      commodityListOptions: [],
      commodityVarietyList: [],
      commodityVarietyListOption: [],
      isInvalid: true,
      edited: false,
      mandatoryFields: []
    };
  }

  componentDidUpdate = () => {
    if (this.state.edited) {
      window.onbeforeunload = () => true;
    } else {
      window.onbeforeunload = undefined;
    }
  };

  componentWillUnmount() {
    window.onbeforeunload = undefined;
  }

  componentWillMount() {
    this.props.actions
      .getMandatoryFieldsList("Contract")
      .then(mandatoryFieldsList => {
        this.setState({
          mandatoryFields: mandatoryFieldsList
            .filter(item => item.enable === true)
            .map(item => item.fieldName)
        });
        console.log(this.state.mandatoryFields);
      });
    const harvestYearId = harvestYearDetail().name;
    const destinationType = "External";
    this.props.actions.getCommodityVariertyList(harvestYearId).then(() => {
      this.props.actions.commodityList();
      if (this.props.contractInfo.commodityId) {
        this.getVariertyList(this.props.contractInfo.commodityId);
      }
    });
    this.props.actions.getCounterpartList(harvestYearId);
    this.props.actions.getContractStage();
    this.props.actions.getContractType();
    this.props.actions.getDestinationByType(destinationType, harvestYearId);
  }

  getVariertyList = id => {
    let mode = this.props.editMode;
    let selectedVariety = this.props.contractInfo
      ? this.props.contractInfo.commodityVarietyId
      : "";
    const { commodityVarietyList } = this.props;
    let option = commodityVarietyList.filter(
      value => value.commodityResponseDTO.id === id
    );
    console.log(option);
    this.setState(prevState => {
      return {
        commodityVarietyListOption: option,
        contractInfo: {
          ...prevState.contractInfo,
          commodityVarietyId:
            mode && !this.handleVarietyonEdit? selectedVariety : option.length>0?option[0].id:selectedVariety
        }
      };
    });
    this.handleVarietyonEdit = true;
  };

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    let { name, value, type, label } = event.target;
    if (name === "commodityId") {
      this.getVariertyList(value);
    }
    if (name === "bushelContracted" || name === "unitPrice") {
      if (value.match(/^\d{0,10}(\.\d{0,2})?$/)) {
        this.updateState(name, value);
        if( name === "unitPrice")
        {
          this.setState({
            estmatederrormessage: true
          })
        }
      }
    } else if (name === "basis") {
      if (value.match(/^[-]?\d{0,10}(\.\d{0,2})?$/)) {
        this.updateState(name, value);
      }
    } else if (name === "notes") {
      if (value.match(/^(.|\n){0,256}$/)) {
        this.updateState(name, value);
      }
    } else if (name === "contractNumber") {
      if (value.match(/^(\w|-){0,21}$/)) {
        this.updateState(name, value);
      }
    } else {
      if(name==="counterpartId"&& label){
        this.setState({ONBOARDED:label.includes('✅')?'ONBOARDED':'VIRTUAL'
      })
  }
  


      this.updateState(name, value);
     
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          contractInfo: {
            ...prevState.contractInfo,
            [name]: value
          }
        };
      },
      () => {
        const { contractInfo } = this.state;
        const reqiredFields = { ...contractInfo };
        delete reqiredFields.destinationId;
        delete reqiredFields.basis;
        delete reqiredFields.notes;
        this.setState({
          isInvalid: validForm(this.state.formErrors, reqiredFields)
        });
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { contractInfo } = this.state;
        // const reqiredFields = { ...contractInfo };
        // delete reqiredFields.counterpartId;
        // delete reqiredFields.destinationId;
        // delete reqiredFields.basis;
        // delete reqiredFields.notes;
        // // this.setState({
        //   isInvalid: validForm(this.state.formErrors, reqiredFields)
        // });
      }
    );
  };

  createContract = e => {
    e.preventDefault();
    const { contractInfo } = this.state;
    contractInfo.harvestYear = harvestYearDetail().name;

    const requestData = { ...contractInfo };
    requestData['counterPartyEnum'] = this.state.ONBOARDED
    requestData.notes = requestData.notes ? requestData.notes : null;
    this.setState({
      isInvalid: true,
      edited: false
    });
    this.props.submitFunction(requestData);
  };

  getfilterCommodityList = commodityVarietyList => {
    let comm = commodityVarietyList !== undefined ? commodityVarietyList : {};

    let commarray = [];
    commarray = Object.keys(comm).map(value => {
      return {
        id: comm[value].commodityResponseDTO.id,
        name: comm[value].commodityResponseDTO.name
      };
    });
    const filteredArr = commarray.reduce((acc, current) => {
      const x = acc.find(item => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    return filteredArr;
  };

  calculateContractValue = () => {
    const { contractInfo } = this.state;
    // console.log('contactprice',contractInfo.unitPrice)
    let amount =
      Math.round(
        (parseFloat(contractInfo.bushelContracted) || 0) *
          ((parseFloat(contractInfo.basis) || 0) +
            (parseFloat(contractInfo.unitPrice) || 0)) *
          100
      ) / 100 || 0;
    contractValue = amount;
    if((amount!=0)&&(!contractInfo.unitPrice))
    {
      if(this.state.estmatederrormessage){
      return "Unit Price Is Required"
      }
      else{
        return `$ ${amount}`;     
      }
    }
    else{
    return `$ ${amount}`;
    }
  };

  handleDateChange = date => {
    if (!this.state.edited) this.setState({ edited: true });
    console.log(formatDate(date));
    if (date) {
      this.setState(
        prevState => {
          return {
            contractInfo: {
              ...prevState.contractInfo,
              maturityDate: formatDate(date)
              //moment(date._d).format("MM/DD/YYYY")
            }
          };
        },
        () => {
          const { contractInfo } = this.state;
          const reqiredFields = { ...contractInfo };
          delete reqiredFields.destinationId;
          delete reqiredFields.basis;
          delete reqiredFields.notes;
          this.setState({
            isInvalid: validForm(this.state.formErrors, reqiredFields)
          });
        }
      );
    }
  };

  checkContractVal = () => {
    return contractValue < 0;
  };

  isCellRequired = cellName => {
    const { mandatoryFields } = this.state;
    return mandatoryFields.includes(cellName);
  };

  checkAllMandatoryCellsAreFilled = () => {
    const { mandatoryFields = [], contractInfo } = this.state;
    let mFields = mandatoryFields.filter(function(item) {
      return item !== "contractValue";
    });
    let blankCells = 0;
    blankCells = mFields.map(
      cell =>
        contractInfo[cell] === "" ||
        contractInfo[cell] === undefined ||
        contractInfo[cell] === null
    );
    return blankCells.includes(true);
  };

  render() {
    const {
      contractInfo,
      commodityVarietyListOption,
      formErrors,
      isInvalid,
      edited
    } = this.state;
  
    const {
      buttonLabel,
      // contractInfo,
      formLabel,
      counterPartList,
      ContractTypeList,
      ContractStageList,
      DestinationList,
      suggestedCounterPart = [],
      suggestedDestinationList = { ticket: [], contract: [] },
      editMode = false
    } = this.props;
    console.log('contactinfofgfgfgf props',this.props)
    console.log('contactinfofgfgfgf state',this.state)
    return (
      <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          {editMode ? (
            <LogInfo
              createdBy={contractInfo.createdBy}
              updatedBy={contractInfo.updatedBy}
              createdAt={contractInfo.createdAt}
              updatedAt={contractInfo.updatedAt}
            />
          ) : (
            <div />
          )}
        </div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container spacing={8}>
            <Grid item xs={12}>
              <InputFiled
                value={contractInfo.contractNumber}
                label="Contract Number"
                type="text"
                disabled={editMode}
                required
                validations={["required", "codeSize", "minSize"]}
                name="contractNumber"
                handleError={this.handleError}
                handleChange={this.handleChange}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Dropdown
                value={contractInfo.contractTypeId}
                label="Contract Type"
                required
                type="text"
                options={ContractTypeList}
                validations={["required"]}
                name="contractTypeId"
                handleChange={this.handleChange}
                handleError={this.handleError}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <label className="maturity-label">Maturity *</label>
                <DatePicker
                  className="date-picker"
                  disablePast
                  autoOk
                  format="MM/dd/yyyy"
                  // label="Maturity"
                  value={contractInfo.maturityDate}
                  onChange={this.handleDateChange}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item sm={6} xs={12}>
              <Dropdown
                value={contractInfo.commodityId}
                label="Commodity"
                required
                type="text"
                options={this.getfilterCommodityList(
                  this.props.commodityVarietyList
                )}
                name="commodityId"
                validations={["required"]}
                handleError={this.handleError}
                handleChange={this.handleChange}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Dropdown
                value={contractInfo.commodityVarietyId}
                label="Variety"
                type="text"
                name="commodityVarietyId"
                required
                validations={["required"]}
                options={commodityVarietyListOption}
                fullform={contractInfo}
                handleError={this.handleError}
                handleChange={this.handleChange}
                disabled={commodityVarietyListOption.length > 0 ? false : true}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                value={contractInfo.contractStageId}
                label="Stage"
                required
                type="text"
                name="contractStageId"
                options={ContractStageList}
                validations={["required"]}
                handleChange={this.handleChange}
                handleError={this.handleError}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                value={contractInfo.counterpartId}
                label="Counterpart"
                type="text"
                name="counterpartId"
                options={counterPartList}
                suggestedData={suggestedCounterPart}
                required
                validations={["required"]}
                handleError={this.handleError}
                handleChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <Dropdown
                value={contractInfo.destinationId}
                label="Delivery Destination (if known or specify in ticketing)"
                type="text"
                name="destinationId"
                required={this.isCellRequired("basis")}
                validations={this.isCellRequired("basis") ? ["required"] : []}
                handleError={this.handleError}
                options={DestinationList}
                suggestedData={suggestedDestinationList.contract}
                handleChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={contractInfo.bushelContracted}
                label="Bushels Contracted"
                required
                type="text"
                name="bushelContracted"
                validations={["onlyNumber", "required"]}
                handleError={this.handleError}
                handleChange={this.handleChange}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <InputFiled
                value={contractInfo.unitPrice}
                label="Unit Price"
                required
                type="text"
                name="unitPrice"
                validations={["onlyNumber", "required"]}
                handleChange={this.handleChange}
                handleError={this.handleError}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <InputFiled
                value={contractInfo.basis}
                required={this.isCellRequired("basis")}
                label="Basis"
                type="text"
                name="basis"
                validations={this.isCellRequired("basis") ? ["required"] : []}
                handleError={this.handleError}
                handleChange={this.handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={this.calculateContractValue()}
                label="Estimated Contract Value"
                type="text"
                disabled
                name="contractValue"
                handleChange={this.handleChange}
                handleError={this.handleError}
              />
              {this.checkContractVal() && (
                <FormHelperText style={{ color: "red" }}>
                  Estimated contract value can not be less than 0, please adjust
                  basis value.
                </FormHelperText>
              )}
            </Grid>
            <Grid item xs={12}>
              <InputFiled
                value={contractInfo.notes}
                label="Notes"
                type="text"
                required={this.isCellRequired("notes")}
                validations={
                  this.isCellRequired("notes")
                    ? ["required", "aboveMaxSize"]
                    : ["aboveMaxSize"]
                }
                onfocusremove={this.onfocusremove}
                name="notes"
                multiline
                rows={2}
                rowsMax={4}
                handleError={this.handleError}
                handleChange={this.handleChange}
              />
            </Grid>
          </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link to="/app/contracts" style={{ color: "blue" }}>
              Cancel
            </Link>
            <Button
              name={buttonLabel}
              disabled={
                isInvalid ||
                this.checkContractVal() ||
                this.checkAllMandatoryCellsAreFilled()
              }
              onclick={this.createContract}
              styleClass="signIn"
            />
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    contractCreated: state.contractReducer.contractCreated,
    commodityList: state.contractReducer.commodityList,
    commodityVarietyList: state.contractReducer.commodityVarietyList,
    counterPartList: state.contractReducer.CounterPart,
    suggestedCounterPart: state.contractReducer.suggestedCounterPart,
    ContractStageList: state.contractReducer.ContractStageList,
    ContractTypeList: state.contractReducer.ContractTypeList,
    DestinationList: state.contractReducer.DestinationList,
    suggestedDestinationList: state.contractReducer.suggestedExternalOptions
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        createContract,
        commodityList,
        getCommodityVariertyList,
        getCounterpartList,
        getContractStage,
        getContractType,
        getDestinationByType,
        getMandatoryFieldsList
      },
      dispatch
    )
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractForm);



// WEBPACK FOOTER //
// ./src/components/private/Contracts/ContractForm.js